import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../services/supabase';

const BRAND  = '#E8940A';
const BRAND2 = '#F5A623';

const ForgotPasswordPage = () => {
  const [email,   setEmail]   = useState('');
  const [loading, setLoading] = useState(false);
  const [sent,    setSent]    = useState(false);
  const [error,   setError]   = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email.trim() || !email.includes('@')) {
      setError('Düzgün email ünvanı daxil edin');
      return;
    }
    setLoading(true);
    try {
      const { error: err } = await supabase.auth.resetPasswordForEmail(email.trim().toLowerCase(), {
        redirectTo: `${window.location.origin}/reset-password`,
      });
      if (err) throw err;
      setSent(true);
    } catch (err) {
      setError(err.message || 'Xəta baş verdi. Yenidən cəhd edin.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { font-family: 'Inter', -apple-system, sans-serif; }

        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(20px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes spin { to { transform: rotate(360deg); } }

        .fp-page {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(160deg, #FFF9F0 0%, #FFF3D6 100%);
          padding: 24px 16px;
        }

        .fp-card {
          width: 100%;
          max-width: 440px;
          background: #fff;
          border-radius: 24px;
          padding: 48px 40px;
          box-shadow: 0 8px 48px rgba(232,148,10,0.12);
          border: 1px solid #FDE68A;
          animation: fadeUp 0.5s ease;
        }

        .fp-logo {
          display: flex;
          align-items: center;
          gap: 10px;
          justify-content: center;
          margin-bottom: 32px;
        }
        .fp-logo-icon {
          width: 44px; height: 44px;
          border-radius: 13px;
          background: linear-gradient(135deg, ${BRAND}, ${BRAND2});
          display: flex; align-items: center; justify-content: center;
          font-size: 22px;
          box-shadow: 0 4px 14px rgba(232,148,10,0.35);
        }
        .fp-logo-name {
          font-size: 22px;
          font-weight: 900;
          color: #1A1207;
        }

        .fp-icon-wrap {
          width: 72px; height: 72px;
          border-radius: 20px;
          background: rgba(232,148,10,0.10);
          border: 2px solid rgba(232,148,10,0.2);
          display: flex; align-items: center; justify-content: center;
          font-size: 32px;
          margin: 0 auto 20px;
        }

        .fp-title {
          font-size: 26px;
          font-weight: 900;
          color: #0F172A;
          text-align: center;
          margin-bottom: 8px;
          letter-spacing: -0.4px;
        }
        .fp-subtitle {
          font-size: 14px;
          color: #64748B;
          text-align: center;
          margin-bottom: 32px;
          line-height: 1.6;
        }

        .fp-form { display: flex; flex-direction: column; gap: 18px; }

        .fp-field { display: flex; flex-direction: column; gap: 7px; }
        .fp-label { font-size: 13px; font-weight: 700; color: #374151; }

        .fp-input-wrap {
          display: flex;
          align-items: center;
          border: 1.5px solid #E2E8F0;
          border-radius: 12px;
          overflow: hidden;
          background: #FAFAFA;
          transition: border-color 0.2s, box-shadow 0.2s;
        }
        .fp-input-wrap:focus-within {
          border-color: ${BRAND};
          box-shadow: 0 0 0 3px rgba(232,148,10,0.12);
          background: #fff;
        }
        .fp-icon {
          padding: 0 12px;
          font-size: 16px;
          line-height: 48px;
          background: #F8FAFC;
          border-right: 1px solid #E2E8F0;
          user-select: none;
        }
        .fp-input {
          flex: 1;
          border: none;
          outline: none;
          padding: 13px 14px;
          font-size: 14px;
          color: #0F172A;
          background: transparent;
          font-family: inherit;
        }

        .fp-error {
          display: flex;
          align-items: center;
          gap: 8px;
          background: #FEF9E7;
          border: 1px solid #FDE68A;
          border-radius: 10px;
          padding: 10px 14px;
          font-size: 13px;
          color: #92400E;
          font-weight: 500;
        }

        .fp-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          background: linear-gradient(135deg, ${BRAND} 0%, ${BRAND2} 100%);
          color: #fff;
          border: none;
          border-radius: 12px;
          padding: 14px;
          font-size: 15px;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.2s;
          box-shadow: 0 4px 18px rgba(232,148,10,0.40);
          font-family: inherit;
        }
        .fp-btn:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(232,148,10,0.50);
        }
        .fp-btn:disabled { opacity: 0.72; cursor: not-allowed; }

        .btn-spinner {
          width: 16px; height: 16px;
          border: 2.5px solid rgba(255,255,255,0.35);
          border-top-color: #fff;
          border-radius: 50%;
          animation: spin 0.7s linear infinite;
        }

        .fp-back {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          margin-top: 20px;
          font-size: 13px;
          color: #64748B;
          text-decoration: none;
          font-weight: 600;
          transition: color 0.2s;
        }
        .fp-back:hover { color: ${BRAND}; }

        /* Success state */
        .fp-success {
          text-align: center;
          padding: 8px 0;
          animation: fadeUp 0.4s ease;
        }
        .fp-success-icon {
          font-size: 56px;
          margin-bottom: 16px;
          display: block;
        }
        .fp-success-title {
          font-size: 22px;
          font-weight: 800;
          color: #0F172A;
          margin-bottom: 10px;
        }
        .fp-success-desc {
          font-size: 14px;
          color: #64748B;
          line-height: 1.65;
          margin-bottom: 28px;
        }
        .fp-success-email {
          font-weight: 700;
          color: ${BRAND};
        }
        .fp-success-note {
          font-size: 12px;
          color: #94A3B8;
          background: #F8FAFC;
          border-radius: 10px;
          padding: 12px 16px;
          margin-bottom: 24px;
          line-height: 1.6;
        }
      `}</style>

      <div className="fp-page">
        <div className="fp-card">

          <div className="fp-logo">
            <div className="fp-logo-icon">☕</div>
            <span className="fp-logo-name">Cafegoo</span>
          </div>

          {sent ? (
            <div className="fp-success">
              <span className="fp-success-icon">📧</span>
              <div className="fp-success-title">Email göndərildi!</div>
              <p className="fp-success-desc">
                <span className="fp-success-email">{email}</span> ünvanına şifrə
                sıfırlama linki göndərildi.
              </p>
              <div className="fp-success-note">
                ⏱ Link 1 saat ərzində etibarlıdır.<br />
                📁 Spam/Junk qovluğunu da yoxlayın.
              </div>
              <Link to="/login" className="fp-btn" style={{ textDecoration: 'none', display: 'flex' }}>
                ← Girişə qayıt
              </Link>
            </div>
          ) : (
            <>
              <div className="fp-icon-wrap">🔑</div>
              <h1 className="fp-title">Şifrəni sıfırla</h1>
              <p className="fp-subtitle">
                Qeydiyyatda olduğunuz email ünvanını daxil edin.<br />
                Şifrə sıfırlama linki göndərəcəyik.
              </p>

              <form onSubmit={handleSubmit} className="fp-form">
                <div className="fp-field">
                  <label className="fp-label">Email ünvanı</label>
                  <div className="fp-input-wrap">
                    <span className="fp-icon">✉️</span>
                    <input
                      className="fp-input"
                      type="email"
                      value={email}
                      onChange={e => setEmail(e.target.value)}
                      placeholder="email@biznesiniz.az"
                      required
                      autoFocus
                    />
                  </div>
                </div>

                {error && (
                  <div className="fp-error">
                    <span>⚠️</span> {error}
                  </div>
                )}

                <button type="submit" className="fp-btn" disabled={loading}>
                  {loading && <span className="btn-spinner" />}
                  {loading ? 'Göndərilir...' : 'Sıfırlama Linki Göndər →'}
                </button>
              </form>

              <Link to="/login" className="fp-back">
                ← Girişə qayıt
              </Link>
            </>
          )}

        </div>
      </div>
    </>
  );
};

export default ForgotPasswordPage;
